// src/pages/module2/Bridge.js
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LogoTransition from "../../components/LogoTransition";
import { API_BASE } from "../../api";


export default function Bridge() {

  const { sessionId, role, phase } = useParams();
  const navigate = useNavigate();

  const [bridgeText, setBridgeText] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadBridge() {
      try {
        const res = await fetch(
          `${API_BASE}/module2/phase/bridge/${sessionId}`
        );
        const data = await res.json();
        setBridgeText(data.bridge || "");
      } catch (e) {
        console.error("Failed to load bridge", e);
      } finally {
        setLoading(false);
      }
    }
    loadBridge();
  }, [sessionId]);

  function handleContinue() {

    const key = `completedClasses_${sessionId}`;
    const completed = JSON.parse(localStorage.getItem(key) || "[]");

    if (!completed.includes(Number(phase))) {
      completed.push(Number(phase));
      localStorage.setItem(key, JSON.stringify(completed));
    }

    navigate(`/module2/${sessionId}/${role}`, { replace: true });
  }

  return (

    <div
      style={{
        minHeight: "100vh",
        padding: "120px 28px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

        background:
          "radial-gradient(circle at 50% 45%, #123044 0%, #081822 55%, #020608 100%)",

        color: "#F5F4ED",
        fontFamily: "Inter, sans-serif"
      }}
    >

      {loading && <LogoTransition />}

      {!loading && (
        <div
          style={{
            maxWidth: 520,
            width: "100%"
          }}
        >

          <h2
            style={{
              marginBottom: 28,
              fontWeight: 400,
              fontSize: 22,
              letterSpacing: 0.4
            }}
          >
            Shared reflection
          </h2>

          <div
            style={{
              fontSize: 15,
              lineHeight: 1.7,
              whiteSpace: "pre-line",
              marginBottom: 48,

              background: "rgba(18,48,68,0.35)",
              border: "1px solid rgba(245,244,237,0.35)",
              borderRadius: 18,
              padding: "24px 22px",
              backdropFilter: "blur(6px)"
            }}
          >
            {bridgeText}
          </div>

          <button
            onClick={handleContinue}
            style={{
              padding: "10px 26px",
              fontSize: 15,
              cursor: "pointer",

              background: "rgba(245,244,237,0.9)",
              color: "#081822",

              border: "none",
              borderRadius: 20,

              fontWeight: 500,

              boxShadow: "0 0 12px rgba(245,244,237,0.35)",

              transition: "all 0.25s ease"
            }}
          >
            Continue
          </button>

        </div>
      )}
    </div>
  );
} 
